<app-gmao-spinner *ngIf="!machine"></app-gmao-spinner>
<ng-container *ngIf="machine">
<p class="w-100 machine-entete">La machine <span>{{machine.numero_serie}}</span> est associée à l'installation <a routerLink="/installation/{{machine.id_installation}}">{{machine.nom_installation}}</a></p>
<div>
    <mat-tab-group mat-align-tabs="center">
        <mat-tab label="Propriétés">
            <app-machine-properties [machine]="machine"></app-machine-properties>
        </mat-tab>
        <mat-tab label="Matériel">
            <app-machine-equipment [identifiant]="identifiant"></app-machine-equipment>
        </mat-tab>
        <!-- <mat-tab label="Base de données">
            <app-machine-database [identifiant]="identifiant"></app-machine-database>
        </mat-tab> -->
        <mat-tab label="Historique">
            <app-machine-historic [identifiant]="identifiant"></app-machine-historic>
        </mat-tab>
        
    </mat-tab-group>
</div>
</ng-container>